import React from 'react'
const Title = () => (
  <h1 className="font-bold text-4xl font-sans mb-4">
    Manage from <span className="text-aktivin-orange font-extrabold">virtual sporting events</span>, <span className="text-aktivin-orange font-extrabold">e-commerce</span>, <span className="text-aktivin-orange font-extrabold">and virtual coaching</span>, all in one web app
  </h1>
)

export default Title
